module.exports = "https://r.nearpod.com/assets/media/image/upgrade-f6b414bbed6fd547e5620c6625c5cf63.svg";